import { React, Table } from '@1337lawyers/design';

export const InvestorInvitations = () => (
  <Table
    headers={['Email', 'Date', 'Issuer', 'Declined', 'Resend']}
    data={[]}
  />
);
